export enum IPages {
    ARTICLES = 'ARTICLES',
    SEARCH = 'SEARCH',
    QUEUE = 'QUEUE',
}
